<script>
export default {
  data() {
    return {
      message: '',
      visible: false
    }
  },
  methods: {
    afterLeave() {
      this.message = ''
    }
  },
  render() {
    return (
      <transition name="fade" onAfterLeave={this.afterLeave}>
        <div class="wrap">
          <div
            class="toast"
            ref="toast"
            v-show={this.visible}
            domPropsInnerHTML={this.message}
          />
          <div
            class="toast shadow"
            ref="shadow"
            domPropsInnerHTML={this.message}
          />
        </div>
      </transition>
    )
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.toast {
  position: fixed;
  left: 50%;
  top: calc(50% - 80px);
  z-index: 99;
  max-width: 670px;
  transform: translate(-50%, -50%);
  padding: 24px 30px;
  color: rgb(230, 230, 230);
  font-size: 26px;
  font-family: PingFangSC-Regular;
  font-weight: normal;
  text-align: center;
  line-height: 34px;
  background-color: #000;
  border-radius: 4px;
  &.shadow {
    // 设置toast 真实宽度
    position: fixed;
    left: auto;
    top: -200px;
    transform: translate(0%, 0%);
    visibility: hidden;
    z-index: -99;
  }
}
</style>
